<template>
	<j-base-select
		:options="options"
		:value="computedValue"
		:allowSelectNothing="false"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	props: {
		for: String, // policyWhereInput || transactionWhereInput
		value: String
	},

	components: {
		JBaseSelect
	},

	data() {
		return {
			options: []
		}
	},

	methods: {
		decideQuery() {
			const transactionsQuery = gql`
				query fetchTransactions {
					transactions {
						list {
							id
							transactionNumber
						}
					}
				}
			`
			let query =
				this.for === "transactionWhereInput" ? transactionsQuery : null
			return query
		},

		decideVariables() {
			return null
		},

		async fetchOptions() {
			let query = this.decideQuery()
			let variables = this.decideVariables()

			const res = await api({ query, variables })

			let resKey =
				this.for === "transactionWhereInput"
					? res?.data?.transactions?.list
					: null

			let label =
				this.for === "transactionWhereInput" ? "transactionNumber" : null

			return resKey
				?.map(item => ({
					name: item?.[label],
					value: item.id
				}))
				?.reverse()
		}
	},

	computed: {
		computedValue() {
			return this.value
		}
	},

	async created() {
		// if value prop exists, use it as default value for JBaseSelect/Dropdown
		if (this.value) {
			this.options.push({ value: this.value, name: this.value })
		}
		// else fetch options
		else {
			this.options = await this.fetchOptions()
		}
	}
}
</script>
